import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useOnboarding } from "@/contexts/OnboardingContext";
import { Rocket } from "lucide-react";

export function WelcomeDialog() {
  const { showWelcome, dismissWelcome, finishOnboarding } = useOnboarding();

  return (
    <Dialog open={showWelcome} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md rounded-2xl border-0 shadow-2xl p-0 overflow-hidden [&>button]:hidden"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        {/* Header gradient */}
        <div className="bg-gradient-to-br from-violet-500 to-purple-600 px-8 pt-8 pb-6 text-center">
          <div className="mx-auto mb-4 flex h-32 w-32 items-center justify-center">
            <img src="/logo-light.png?v=6" alt="FabChat" className="h-full w-full object-contain drop-shadow-lg block dark:hidden" />
            <img src="/logo.png?v=6" alt="FabChat" className="h-full w-full object-contain drop-shadow-lg hidden dark:block" />
          </div>
          <h2 className="text-2xl font-bold text-white">
            Bem-vindo à FabChat! <Rocket className="inline h-6 w-6 ml-1" />
          </h2>
        </div>

        {/* Body */}
        <div className="px-8 py-6 text-center space-y-4">
          <p className="text-muted-foreground text-sm leading-relaxed">
            Estamos muito felizes em ter você aqui. Vamos deixar sua operação de atendimento pronta em poucos minutos.
          </p>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Preparamos um <strong className="text-foreground">passo a passo rápido</strong> para você configurar sua inteligência artificial. Vamos começar?
          </p>

          <Button
            onClick={dismissWelcome}
            className="w-full bg-gradient-to-r from-violet-500 to-purple-600 hover:from-violet-600 hover:to-purple-700 text-white font-semibold h-12 rounded-xl text-base shadow-lg hover:shadow-xl transition-all"
          >
            Começar o tour
          </Button>

          <button
            onClick={finishOnboarding}
            className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors underline underline-offset-2"
          >
            Pular tutorial
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
